import React from 'react'
import BrandLayout from '../components/Layouts/BrandLayout'
import ProtectByAccessToken from '../components/Security/ProtectByAccessToken'
import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import OnboardingDialogContainer from '../containers/OnboardingDialog/OnboardingDialog.container'
import PurchaseOrderStatusContainer from '../containers/PurchaseOrderStatus/PurchaseOrderStatus.container'

/**
 * The StatusPurchaseOrder's page.
 */
const StatusPurchaseOrder = () => {
  return (
    <AuthorizationProviderContainer>
      <ProtectByAccessToken>
        <BrandLayout>
          <PurchaseOrderStatusContainer />
          <OnboardingDialogContainer />
        </BrandLayout>
      </ProtectByAccessToken>
    </AuthorizationProviderContainer>
  )
}

export default StatusPurchaseOrder
